// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__15f0A","rootNoMargin":"styles_rootNoMargin__2F-Em"};